import { useState } from 'react';
import { Button, Input, Select } from '@/shared/ui';
import patterns from '@/shared/ui/styles/patterns.module.css';
import { US_STATES } from '../utils/usStates';
import { useProviderCredentials } from '../hooks/useProviderCredentials';
import styles from './ProviderCredentialsTable.module.css';

interface AddProviderRowProps {
  onDone: () => void;
}

export function AddProviderRow({ onDone }: AddProviderRowProps) {
  const { addProvider } = useProviderCredentials();
  const [name, setName] = useState('');
  const [individualNpi, setIndividualNpi] = useState('');
  const [licenseNumber, setLicenseNumber] = useState('');
  const [licenseState, setLicenseState] = useState('');

  function handleSave() {
    addProvider.mutate(
      {
        name,
        individualNpi,
        licenseNumber: licenseNumber || undefined,
        licenseState: licenseState || undefined,
      },
      { onSuccess: onDone },
    );
  }

  return (
    <div className={`${patterns.gridTableRow} ${styles.gridCols5}`}>
      <Input
        placeholder="Provider name, e.g. Dr. Jane Doe, DDS"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <Input
        className={styles.mono}
        placeholder="10-digit NPI"
        value={individualNpi}
        onChange={(e) => setIndividualNpi(e.target.value)}
      />
      <Input
        className={styles.mono}
        placeholder="License #"
        value={licenseNumber}
        onChange={(e) => setLicenseNumber(e.target.value)}
      />
      <Select
        options={US_STATES}
        placeholder="State"
        value={licenseState}
        onChange={(e) => setLicenseState(e.target.value)}
      />
      <div className={styles.actionCell}>
        <Button
          size="sm"
          onClick={handleSave}
          isLoading={addProvider.isPending}
          disabled={!name || !individualNpi}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
